module.exports = __webpack_public_path__ + "static/media/V4.7e34b0ac.png";